import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { LineLoss } from "@/features/lines/hooks";
import { api } from "@/lib/api-client";

interface RegisterMachineLossInput {
  lossType: "REJECT" | "WASTE" | "REWORK";
  quantity: number;
  reason?: string;
}

// Reporte de refugo por máquina. Reusa o endpoint de perda da linha,
// enviando machineId obrigatório (caminho único do modo por-máquina). O refugo da linha é
// a soma das perdas por máquina (calculate_oee mode-aware) e a Qualidade da linha/máquina
// deriva dele. Invalidação COMPLETA (molde de useRegisterProductionEntry): losses + lines +
// machines + oee (cobre by-machine pelo prefixo) + parameters + production active. Realtime
// (OEE_UPDATED) cobre os demais viewers.
export function useRegisterMachineLoss(machineId: string, lineId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: RegisterMachineLossInput) =>
      api.post<LineLoss>(`/api/v1/lines/${lineId}/production-losses`, { ...data, machineId }),
    meta: { skipErrorToast: true },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["lines", lineId, "losses"] });
      void qc.invalidateQueries({ queryKey: ["lines", lineId] });
      void qc.invalidateQueries({ queryKey: ["machines", lineId] });
      void qc.invalidateQueries({ queryKey: ["oee", lineId] });
      void qc.invalidateQueries({ queryKey: ["parameters", machineId] });
      void qc.invalidateQueries({ queryKey: ["production", "active", lineId] });
    },
  });
}
